import "./App.css";
import ApplicationRouter from "./router";
import { BrowserRouter } from "react-router-dom";
import { ProfileProvider } from "./components/portfolio/context/ProfileContext";
import { ThemeProvider } from "./components/portfolio/context/ThemeContext";
function App() {
  return (
    <div className="app-grid-container">
      <ProfileProvider>
        <ThemeProvider>
          <BrowserRouter>
            <ApplicationRouter />
          </BrowserRouter>
        </ThemeProvider>
      </ProfileProvider>
    </div>
  );
}

export default App;
